module.exports = __webpack_public_path__ + "media/images/PDI-a468c968ae9f010b592d65e02a4c56ff.png";